import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import history from '../../../utils/history';
import { clearCart } from '../estoqueCart/actions';
import { loadSocilitacaoSuccess, loadSolicitacaoFailure, loadSolicitacaoRequest } from './actions';

export function* loadSolicitacaoRetorno({
  payload,
}: ReturnType<typeof loadSolicitacaoRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}solicitarRetornoMercadoria&token=${state.auth.token}`,
      { centroDistribuicao: payload.cddAtivo, solicitacoes: payload.solicitacoes }
    );

    yield put(loadSocilitacaoSuccess(response.data.solicitarRetornoMercadoria));
    yield put(clearCart());
    response.data.notas.length < 2
      ? Swal.fire({
          title: `Solicitação de retorno efetuada com sucesso! Você pode acompanhar pela solicitação de retorno n°${response.data.notas}`,
          html: '',
          icon: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.removeItem('persist:SolicitacoesRetorno');
            history.push('/dashboard/estoque');
          }
        })
      : Swal.fire({
          title: `Sua solicitação de retorno de mercadoria foi efetuada com sucesso! Você pode acompanhar pelas solicitações de retorno nᵒˢ ${response.data.notas
            .toString()
            .replace(',', ', ')} `,
          html: '',
          icon: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.removeItem('persist:SolicitacoesRetorno');
            history.push('/dashboard/estoque');
          }
        });
  } catch (error: any) {
    yield put(loadSolicitacaoFailure());

    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro na solicitação de retorno, por favor atualize a página, se persistir contate o suporte técnico.',
        icon: 'warning',
      });
    }
  }
}
